(() => {
  'use strict';
  const close = dialog => {
    dialog.close();
    document.querySelectorAll('[data-e2-open]').forEach(el => {
      if (el.dataset.e2Open === dialog.id) el.setAttribute('aria-expanded', 'false');
    });
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-e2-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.e2Open);
      if (!dialog) return;
      document.querySelectorAll('.ev2 dialog[open]').forEach(close);
      dialog.showModal(); opener.setAttribute('aria-expanded', 'true');
    }
    const closer = event.target.closest('[data-e2-close]');
    if (closer) close(closer.closest('dialog'));
    if (event.target.closest('.ev2 dialog a[href]')) document.querySelectorAll('.ev2 dialog[open]').forEach(close);
    const qty = event.target.closest('[data-e2-qty]');
    if (qty) {
      const input = qty.closest('.e2-quantity').querySelector('input');
      input.value = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + Number(qty.dataset.e2Qty)));
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }
    if (event.target.closest('[data-e2-privacy]')) {
      const feedback = document.querySelector('.e2-privacy-feedback');
      if (window.privacyBanner?.showPreferences) {
        Promise.resolve(window.privacyBanner.showPreferences()).catch(() => {if(feedback)feedback.hidden=false;});
      } else if (feedback) feedback.hidden = false;
    }
  });
  document.addEventListener('cancel', event => {
    if (event.target.matches('.ev2 dialog')) {
      document.querySelectorAll('[data-e2-open]').forEach(el => {
        if (el.dataset.e2Open === event.target.id) el.setAttribute('aria-expanded', 'false');
      });
    }
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-e2-sort]')) {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', event.target.value); url.searchParams.delete('page');
      location.assign(url.href);
    }
    if (event.target.matches('[data-e2-variant]')) {
      const option = event.target.selectedOptions[0], scope = event.target.closest('.ev2');
      scope.querySelectorAll('[data-e2-price]').forEach(el => el.textContent = option.dataset.price);
      scope.querySelectorAll('[data-e2-format]').forEach(el => el.textContent = option.dataset.title);
      scope.querySelectorAll('button[name="add"]').forEach(button => {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Bientôt disponible' : 'Ajouter au panier ↗';
      });
      const url = new URL(location.href); url.searchParams.set('variant', option.value);
      history.replaceState(null, '', url.href);
    }
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-e2-search]')) {
      const input = event.target.querySelector('[name="q"]');
      input.value = input.value.replace(/tag:source-tableau/g, '').trim() + ' tag:source-tableau';
    }
  });
  // Delegated handlers keep sections interactive after updates in the Shopify editor.
  document.addEventListener('shopify:section:unload', () => {
    document.querySelectorAll('.ev2 dialog[open]').forEach(close);
  });
})();
